import {
  CLINIC_LIST,
  CLINIC_LIST_RES,
  SWITCH_CLINIC,
  SWITCH_CLINIC_RES,
} from './clinic.types'

export const getClinicList = (params) => ({
  type: CLINIC_LIST,
  payload: params,
})
export const clinicListResponse = (res) => ({
  type: CLINIC_LIST_RES,
  payload: res,
})

export const switchClinic = (params) => ({
  type: SWITCH_CLINIC,
  payload: params,
})
export const switchClinicResponse = (res) => ({
  type: SWITCH_CLINIC_RES,
  payload: res,
})
